module.exports = __webpack_public_path__ + "img/icon_wallet_arrow.251cd0ff.svg";